import React from "react";
import { Download } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { useInstallPWA } from "../hooks/usePWA";
import { IOSInstallPopup } from "./pwa/IOSInstallPopup";

/**
 * Bouton d'installation PWA
 * - Chrome / Edge / Android : beforeinstallprompt → installation native (via useInstallPWA)
 * - iOS Safari              : popup pas-à-pas "Partager → Sur l'écran d'accueil" (via IOSInstallPopup)
 * - Déjà installé (standalone) : invisible
 */
export default function InstallPWA() {
  const { t } = useLanguage();
  const { showButton, isIOS, showPopup, setShowPopup, handleClick, popupRef } = useInstallPWA();

  if (!showButton) return null;

  return (
    <div className="relative" data-testid="install-pwa-wrapper">
      <button
        onClick={handleClick}
        className="flex items-center gap-1.5 px-3 py-1.5 text-xs bg-[#C17F59] text-[#F9F6F0] hover:bg-[#A86A46] transition-all duration-200 font-medium"
        style={{ fontFamily: "'Lora', Georgia, serif", borderRadius: "2px", letterSpacing: "0.04em" }}
        data-testid="install-pwa-btn"
        title={isIOS ? t("pwa.ios_title") : t("pwa.install")}
      >
        <Download size={12} strokeWidth={1.5} />
        {t("pwa.install")}
      </button>
      {isIOS && showPopup && (
        <IOSInstallPopup popupRef={popupRef} onClose={() => setShowPopup(false)} />
      )}
    </div>
  );
}
